export const getComponentId = (uuid?: string): string => `id_${uuid}`
